/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTypewriter} from '@fortawesome/pro-duotone-svg-icons';

const PublishersIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faTypewriter} {...props} />
);

export default PublishersIcon;
